import "./App.css";
import "./global.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginMain from "./pages/login/LoginMain";
import SignUpMain from "./pages/signup/SignUpMain";
import OnBoardingMain from "./pages/onboarding/OnBoardingMain";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./components/ProtectedRoute";
import { useGetUserProfileQuery } from "./rtk-query/slices/profile/profileSlice";
import { Spinner } from "react-bootstrap";
import CreateProductMain from "./pages/createProduct/CreateProductMain";
import ForgotPasswordMain from "./pages/forgotPassword/ForgotPasswordMain";
import ResetPasswordMain from "./pages/resetPassword/ResetPasswordMain";
import VerifyTokenMain from "./pages/verifyToken/VerifyTokenMain";
import HomeMain from "./pages/home/HomeMain";
import ProductsMain from "./pages/products/ProductsMain";
import "flatpickr/dist/flatpickr.min.css";
import BookingsMain from "./pages/bookings/BookingsMain";
import EditProfileMain from "./pages/edit-profile/EditProfileMain";
import FinanceMain from "./pages/finance/FinanceMain";
import { baseAPI } from "./rtk-query/baseApi";
import ViewProfileMain from "./pages/view-profile/ViewProfileMain";
import BookingDetailMain from "./pages/booking-detail/BookingDetailMain";
import VerifyProfileMain from "./pages/verify-profile/VerifyProfileMain";
import SpecialOffersMain from "./pages/special-offers/SpecialOffersMain";


function App() {

  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
  console.warn = () => {}
  console.info = () => {}


  const { data: userProfile, isLoading: isUserProfileLoading } =
    useGetUserProfileQuery();

  const handleRefetchUserData = async (token) => {
    await baseAPI.util.resetApiState();
    localStorage.setItem("DODLoginToken", token);
  };

  //  get the value from query token and store it in the local storage
  const token = new URLSearchParams(window.location.search).get("token");
  const createdBy = new URLSearchParams(window.location.search).get("created_by");

  if (token) {
    // invalidates all queries in rtk query
    handleRefetchUserData(token);
  }

  if(createdBy){
    localStorage.setItem("DODAdminCreatedBy", createdBy);
  }

  return (
    <Router>
      <ToastContainer />
      {isUserProfileLoading ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Spinner
            animation="border"
            role="status"
            style={{
              width: "4rem", // Adjust the width for a bigger spinner
              height: "4rem", // Adjust the height for a bigger spinner
              color: "#EB662B", // Set the color of the spinner
            }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div>
          <Routes>
            <Route path="/login" element={<LoginMain />} />
            <Route path="/signup" element={<SignUpMain />} />
            <Route path="/forgot-password" element={<ForgotPasswordMain />} />
            <Route path="/reset-password" element={<ResetPasswordMain />} />
            <Route path="/verify-token" element={<VerifyTokenMain />} />
            <Route
              path="/verify-supplier/:token"
              element={<VerifyProfileMain />}
            />
            <Route
              path="/edit-profile"
              element={<ProtectedRoute children={<EditProfileMain />} />}
            />
            <Route
              path="/view-profile"
              element={<ProtectedRoute children={<ViewProfileMain />} />}
            />
            <Route
              path="/"
              element={<ProtectedRoute children={<HomeMain />} />}
            />
            <Route
              path="/dashboard"
              element={<ProtectedRoute children={<HomeMain />} />}
            />
            <Route
              path="/onboarding"
              element={<ProtectedRoute children={<OnBoardingMain />} />}
            />
            {/* <Route
              path="/create-product"
              element={<ProtectedRoute children={<CreateProductMain />} />}
            /> */}
            <Route
              path="/products"
              element={<ProtectedRoute children={<ProductsMain />} />}
            />

            {/* <Route
              path="/special-offers"
              element={<ProtectedRoute children={<SpecialOffersMain />} />}
            /> */}
            <Route
              path="/bookings"
              element={<ProtectedRoute children={<BookingsMain />} />}
            />
            <Route
              path="/bookings/:id"
              element={<ProtectedRoute children={<BookingDetailMain />} />}
            />
            <Route
              path="/finance"
              element={<ProtectedRoute children={<FinanceMain />} />}
            />
            <Route path="*" element={<div>not found</div>} />
          </Routes>
        </div>
      )}
    </Router>
  );
}

export default App;
